<template>
  <div class="mian_top_box">
    <div class="top_bar_bg">
      <div
        @click="goToUseVideo"
        class="top_bar_right"
        style="display: flex; flex-direction: row"
      >
        {{ t("video.left") }}
        <!-- <img :src="img[lang]" width="20px" alt=""> -->
      </div>
      <div class="top_bar_center">
        <a
          style="all: unset; cursor: pointer; display: flex"
          href="https://apps.apple.com/app/id6499319651"
        >
          <img src="../assets/ios.svg" width="20px" alt="" />
        </a>
        <div style="width: 40px"></div>
        <a
          style="all: unset; cursor: pointer; display: flex"
          @click="onOpenModle"
        >
          <img src="../assets/android.svg" width="20px" alt="" />
        </a>
      </div>
      <div @click="onSwich" class="top_bar_right">
        <span v-show="!swich">{{ t("two.exchange") }}</span>
        <img v-show="swich" src="../assets/back.svg" width="22px" alt="" />
      </div>
    </div>
    <a-modal
      v-model:open="openAndroidModle"
      :footer="null"
      :maskClosable="false"
      centered
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-bottom: 12px;
        "
      >
        <div style="text-align: center; font-size: 15px; font-weight: 500">
          {{ t("download.title") }}
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 12px;
          "
        >
          <!-- <div class="android_button_box">
            <a
              style="
                all: unset;
                cursor: pointer;
                display: flex;
                align-items: center;
              "
              href="https://lingxi.enewie.com/babel/download?apid=BABEL&os=ANDROID"
            >
              <img
                src="../assets/android_package.svg"
                width="20px"
                style="margin-right: 4px"
                alt=""
              />
              {{ t("download.package") }}</a
            >
          </div> -->
          <div class="android_button_box">
            <a
              style="
                all: unset;
                cursor: pointer;
                display: flex;
                align-items: center;
              "
              href="https://a.app.qq.com/o/simple.jsp?pkgname=com.enewie.babel"
            >
              <img
                src="../assets/yingyongbao.svg"
                width="20px"
                style="margin-right: 4px"
                alt=""
              />
              应用宝</a
            >
          </div>
          <div class="android_button_box">
            <a
              style="
                all: unset;
                cursor: pointer;
                display: flex;
                align-items: center;
              "
              href="https://play.google.com/store/apps/details?id=com.enewie.babel"
            >
              <img
                src="../assets/google_play.svg"
                width="20px"
                style="margin-right: 4px"
                alt=""
              />
              Google Play
            </a>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";
const emit = defineEmits(["sendSwich"]);
import { useI18n } from "vue-i18n";
import { ref } from "vue";

const { t, locale } = useI18n();

const lang = ref("zh");
if (locale.value != "zh-CN" && locale.value != "zh") {
  lang.value = "en";
}
// const img = {
//     zh: new URL('@/assets/lang_zh.svg', import.meta.url).href,
//     en: new URL('@/assets/lang_en.svg', import.meta.url).href,
// };
const props = defineProps({
  swich: Boolean,
});
const onSwich = () => {
  emit("sendSwich", props.swich);
};

const goToUseVideo = () => {
  if (props.swich) {
    emit("sendSwich", props.swich);
  }
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: "smooth",
  });
};

const openAndroidModle = ref(false); //打开弹框
//  href="https://lingxi.enewie.com/babel/download?apid=BABEL&os=ANDROID"
const onOpenModle = () => {
  openAndroidModle.value = true;
};
</script>

<style scoped>
.mian_top_box {
  position: fixed;
  top: 8px;
  z-index: 1000;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
}

.top_bar_bg {
  height: 28px;
  position: relative;
  background-color: #332d4166;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  margin: 0 22px;
  border-radius: 4px;
}

.top_bar_center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
}

.top_bar_right {
  color: white;
  font-size: 12px;
  cursor: pointer;
}
</style>
